import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
	selector: 'nce-ops-home',
	templateUrl: 'nce-ops-home.component.html'
})
export class NceOpsHomeComponent {

    constructor(
        private _layoutService: LayoutService
	){}
	
    ngOnInit(){
        this._layoutService.setCurrentPage('nce-ops-home');
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/home/components/nce-ops-home.component.ts